module.exports = __webpack_public_path__ + "img/bgc.38ab3a60.png";